import React, { useState } from "react";
import { Trash2, CheckCircle2, CalendarClock } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { fmtDate, fromLocalInput, isAdmin } from "../../lib/customers";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

const NoteForm = ({ cid, works, reload }) => {
  const [text, setText] = useState("");
  const [workId, setWorkId] = useState("");
  const [fu, setFu] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!text.trim()) { toast.error("Note likhein"); return; }
    setBusy(true);
    try { await api.post(`/customers/${cid}/notes`, { text, work_id: workId || null, followup_at: fromLocalInput(fu) }); toast.success("Note save ho gaya"); setText(""); setWorkId(""); setFu(""); reload(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg bg-slate-50 border border-slate-200 p-4 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm" data-testid="note-form">
      <div className="sm:col-span-2"><Label className="text-xs">Note</Label><Textarea rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder="e.g. Admit card aane par download karna hai" data-testid="note-text" /></div>
      <div>
        <Label className="text-xs">Related Service (optional)</Label>
        <select value={workId} onChange={(e) => setWorkId(e.target.value)} className="w-full h-9 rounded-md border border-input bg-white px-2" data-testid="note-work">
          <option value="">—</option>
          {works.map((w) => <option key={w.id} value={w.id}>{w.work_code} {w.service_name}</option>)}
        </select>
      </div>
      <div><Label className="text-xs">Follow-up Date (optional)</Label><Input type="datetime-local" value={fu} onChange={(e) => setFu(e.target.value)} data-testid="note-followup" /></div>
      <div className="sm:col-span-2"><Button onClick={save} disabled={busy} className="bg-teal-700 hover:bg-teal-800 text-white" data-testid="note-save-btn">{busy ? "Saving…" : "Add Note"}</Button></div>
    </div>
  );
};

const NoteItem = ({ cid, n, reload }) => {
  const done = async () => { try { await api.patch(`/customers/${cid}/notes/${n.id}`, { followup_status: "Done" }); reload(); } catch { toast.error("Failed"); } };
  const del = async () => { if (!window.confirm("Note delete karein?")) return; try { await api.delete(`/customers/${cid}/notes/${n.id}`); reload(); } catch { toast.error("Failed"); } };
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3 text-sm" data-testid={`note-${n.id}`}>
      <div className="whitespace-pre-wrap text-slate-900">{n.text}</div>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2 text-xs text-slate-500">
        <span>{fmtDate(n.created_at, true)} · {n.created_by}</span>
        {n.work_name && <span className="px-2 py-0.5 rounded-full bg-slate-100 text-slate-700">{n.work_name}</span>}
        {n.followup_at && <span className="inline-flex items-center gap-1"><CalendarClock className="w-3 h-3" />{fmtDate(n.followup_at, true)}
          <b className={n.followup_status === "Done" ? "text-green-700" : "text-amber-700"} data-testid={`note-fu-status-${n.id}`}>{n.followup_status}</b></span>}
        <span className="ml-auto flex gap-1">
          {n.followup_at && n.followup_status !== "Done" && <Button size="sm" variant="outline" onClick={done} data-testid={`note-done-${n.id}`}><CheckCircle2 className="w-3 h-3 mr-1" /> Done</Button>}
          {isAdmin() && <Button size="sm" variant="ghost" className="text-red-600" onClick={del} data-testid={`note-delete-${n.id}`}><Trash2 className="w-3 h-3" /></Button>}
        </span>
      </div>
    </div>
  );
};

export const NotesTab = ({ c, notes, works, reload }) => (
  <div className="mt-3 space-y-3" data-testid="notes-tab">
    <NoteForm cid={c.id} works={works} reload={reload} />
    {notes.length === 0 && <div className="text-sm text-slate-500">Abhi koi note nahi hai.</div>}
    {notes.map((n) => <NoteItem key={n.id} cid={c.id} n={n} reload={reload} />)}
  </div>
);
